// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import {Mobile, UntilTablet} from '../../utils/responsive';

import style from './FloatingBottom.scss';

import type { Node } from 'react';

type Props = {
  children: Node;
  offSetY: number;
  untilTablet?: boolean;
};

export default class FloatingBottom extends Component<Props> {
  render() {
    const { offSetY, untilTablet } = this.props;
    
    const Resp = untilTablet ? UntilTablet : Mobile;

    return (
      <Resp>
        <Helmet key="helmet">
          <style type="text/css">{`
              div#root {
                  padding-bottom: ${offSetY}px!important;
              }
          `}</style>
        </Helmet>
        <section className={style.floatingBottom}>
          {this.props.children}
        </section>
      </Resp>
    );
  }
}

FloatingBottom.propTypes = {
  offSetY: PropTypes.number.isRequired,
  untilTablet: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/FloatingBottom/FloatingBottom.jsx